<template>
  <div class="w-full">
    <Listbox v-model="selected" v-slot="{ open }">
      <div class="relative w-full">
        <ListboxButton
          class="w-full bg-brand-green rounded text-brand-black focus:border-brand-green focus:ring-brand-green bg-white"
        >
          <div class="flex flex-row justify-between">
            <div class="grow items-center text-center w-full">
              <p class="text-center md:text-left text-white py-2 pl-3">Send</p>
            </div>

            <div class="flex flex-row">
              <div class="flex border border-green-700"></div>
              <div
                class="flex items-center px-2 rounded-tr rounded-br"
                :class="[open ? 'bg-green-700' : '']"
              >
                <ChevronDownIcon class="w-5 h-5 text-white" v-if="!open" />
                <ChevronUpIcon class="w-5 h-5 text-white" v-if="open" />
              </div>
            </div>
          </div>
        </ListboxButton>

        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="absolute right-0 w-full py-1 mt-3 overflow-auto bg-white rounded-lg border-2 border-brand-green shadow-lg z-20"
            style="min-width: 200px"
          >
            <ListboxOption as="template">
              <li
                class="cursor-pointer select-none relative px-4 md:pl-10 md:pr-4 focus:bg-brand-green"
                @click="openEmailShareModal"
              >
                <div class="flex flex-row py-3 border-b border-brand-light-gray">
                  <div class="flex items-center mr-3">
                    <InboxInIcon class="w-7 h-7 text-brand-green" />
                  </div>
                  <div class="flex items-center">
                    <p>Send Email</p>
                  </div>
                </div>
              </li>
            </ListboxOption>
            <ListboxOption as="template">
              <li
                class="cursor-pointer select-none relative px-4 md:pl-10 md:pr-4 focus:bg-brand-green"
                @click="openQRModal"
              >
                <div class="flex flex-row py-3 border-b border-brand-light-gray">
                  <div class="flex items-center mr-3">
                    <QrcodeIcon class="text-brand-green w-7 h-7" />
                  </div>
                  <div class="flex items-center">
                    <p>Generate QR Code</p>
                  </div>
                </div>
              </li>
            </ListboxOption>
            <!-- <ListboxOption as="template">
              <li
                class="cursor-default select-none relative px-4 md:pl-10 md:pr-4 focus:bg-brand-green"
                @click="openSMSModal"
              >
                <div class="flex flex-row py-3 border-b border-brand-light-gray">
                  <div class="flex items-center mr-3">
                    <ChatIcon class="w-7 h-7 text-brand-green" />
                  </div>
                  <div class="flex items-center">
                    <p>Send Text</p>
                  </div>
                </div>
              </li>
            </ListboxOption> -->
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>
  </div>
</template>
<script>
import {
  ChevronUpIcon,
  ChevronDownIcon,
  InboxInIcon,
  QrcodeIcon
  // ChatIcon
} from "@heroicons/vue/outline"

import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue"

export default {
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    InboxInIcon,
    QrcodeIcon,
    // ChatIcon,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  emits: ["email", "qr", "sms"],
  data() {
    return {
      selected: null
    }
  },
  methods: {
    openEmailShareModal() {
      this.$emit("email")
    },
    openQRModal() {
      this.$emit("qr")
    },
    openSMSModal() {
      this.$emit("sms")
    }
  }
}
</script>
